import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, Send, Pencil, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useEmitirBorrador, useDescartarBorrador } from './api';

interface Props {
  condoId: string;
  gastoId: string;
}

export function BorradorActions({ condoId, gastoId }: Props) {
  const navigate = useNavigate();
  const emitir = useEmitirBorrador(condoId);
  const descartar = useDescartarBorrador(condoId);
  const [showDescartar, setShowDescartar] = useState(false);

  async function handleEmitir() {
    try {
      await emitir.mutateAsync(gastoId);
      toast.success('Gasto comun emitido', {
        description: 'Se generaron los cargos por unidad.',
      });
    } catch {
      toast.error('No se pudo emitir el gasto comun');
    }
  }

  async function handleDescartar() {
    try {
      await descartar.mutateAsync(gastoId);
      toast.success('Borrador descartado');
      navigate(`/app/condominios/${condoId}/gastos-comunes`);
    } catch {
      toast.error('No se pudo descartar el borrador');
    }
  }

  return (
    <>
      <div className="flex items-center gap-2">
        <Button onClick={handleEmitir} disabled={emitir.isPending}>
          {emitir.isPending ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <Send className="h-4 w-4" />
          )}
          Emitir
        </Button>
        <Button
          variant="outline"
          onClick={() => navigate(`/app/condominios/${condoId}/gastos-comunes/${gastoId}/editar`)}
        >
          <Pencil className="h-4 w-4" />
          Editar
        </Button>
        <Button
          variant="danger"
          onClick={() => setShowDescartar(true)}
          disabled={descartar.isPending}
        >
          <Trash2 className="h-4 w-4" />
          Descartar
        </Button>
      </div>

      <Dialog open={showDescartar} onOpenChange={setShowDescartar}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Descartar borrador</DialogTitle>
            <DialogDescription>
              Esta accion eliminara el borrador permanentemente. No se puede deshacer.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowDescartar(false)}>
              Cancelar
            </Button>
            <Button
              variant="danger"
              onClick={handleDescartar}
              disabled={descartar.isPending}
            >
              {descartar.isPending ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                'Descartar'
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
